import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'
import { getLogConfig, normalizeEnv } from '@telus/datadog'

import { envVar } from '@babylon/babylon-env'

import { version } from '../package.json'

const applicationId = envVar('DD_APP_ID')
const clientToken = envVar('DD_CLIENT_TOKEN')
const rawEnv = envVar('ENVIRONMENT')
const env = normalizeEnv(rawEnv)

export const initDatadog = () => {
  // Temporary debug logging
  console.log('[Clinical Portal Datadog Debug]')
  console.log('Raw ENVIRONMENT:', rawEnv)
  console.log('Normalized env:', env)
  console.log('DD_CLIENT_TOKEN present:', clientToken)
  console.log('DD_APP_ID present:', !!applicationId)
  console.log('Will skip initialization?', env === 'local')

  if (env === 'local') {
    console.log('[Datadog] Skipping initialization for local environment')
    return
  }

  if (!clientToken) {
    console.warn('[Datadog] Missing client token.')
    return
  }

  datadogLogs.init(
    getLogConfig({
      clientToken,
      service: 'clinical-portal',
      version,
      env,
    })
  )

  datadogLogs.onReady(() => {
    datadogLogs.logger.error('[Datadog] Logs initialized successfully')
    console.log('[Datadog] Logs initialized successfully')
  })

  if (!applicationId) {
    console.warn('[Datadog] Missing applicationId.')
    return
  }

  datadogRum.init({
    applicationId,
    clientToken,
    site: 'datadoghq.com',
    service: 'clinical-portal',
    env,
    version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0, // disable session replay
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: false,
    traceSampleRate: 100,
    telemetrySampleRate: 100,
    defaultPrivacyLevel: 'mask',
    enablePrivacyForActionName: true,
  })
}

export const datadogSetUser = (user: {
  id: string
  userId: string
  roles: string
}) => {
  datadogLogs.setUser(user)
  if (!applicationId) return
  datadogRum.setUser(user)
}
